{
  "recaptcha_site_key": "6LeUpqwcAAAAAIbPGZBewpl-dRr-Ca7x86v_8Mc0",
  "firebase_api_key": "AIzaSyCiap1CNmRfZ2eNXKMmjEmoYLCc197cUiI",
  "release": "2129f1f5e14aa32b50d56727cff0243133910b5b"
}
